var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _circle, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoexams(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 849.27339,
    height: 842.0024,
    viewBox: "0 0 849.27339 842.0024",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1017.36324,449.9988a420.16054,420.16054,0,0,1-24.06988,140.65c-.01.03-.02.05-.03.08-.07.21-.14.4-.22.61005v.01q-5.115,14.36993-11.24,28.26a420.75416,420.75416,0,0,1-37.06,66.82q-5.22,7.71-10.81,15.17-6.15,8.25-12.69,16.17-6.02994,7.305-12.38,14.33-7.545,8.36993-15.54,16.31a421.1605,421.1605,0,0,1-39.88,35q-3.68994,2.865-7.46,5.63-8.775,6.47992-17.9,12.5a417.43693,417.43693,0,0,1-41.57,24.16c-2.47,1.26-4.96,2.5-7.46,3.7q-14.505,7.005-29.6,12.89c-2.87,1.12994-5.75,2.22-8.66,3.27-.49.19-.98.37-1.48.54a418.30469,418.30469,0,0,1-107.06,23.37994q-3.81.34506-7.63.58-4.05.285-8.11.46c-2.14.11-4.27.19-6.42.25-.44.02-.89.04-1.33.04q-4.335.135-8.7.17c-1.23.01-2.46.02-3.7.02-.58,0-1.16,0-1.74-.01q-12.58494-.045-24.98-.82c-.17-.01-.34-.03-.51-.03-2.96-.2-5.91-.41-8.85-.67q-15.705-1.32-31.07-3.80005-3.54-.555-7.06-1.19995-15.285-2.70008-30.17-6.51-4.425-1.125-8.8-2.35a416.97535,416.97535,0,0,1-49.47-17.18q-13.875-5.82-27.23-12.58-6.015-3.045-11.91-6.28c-1.07-.58-2.13-1.17-3.19-1.76q-11.61-6.48-22.74-13.66-9.12-5.865-17.9-12.2c-.72-.5-1.43-1.02-2.13995-1.54q-6.73507-4.905-13.25-10.06-14.175-11.23507-27.34-23.61-9.105-8.54992-17.68-17.63995a421.7005,421.7005,0,0,1-79.77-120.33q-6.21-14.175-11.4-28.87a.1852.1852,0,0,1-.02-.07,420.34592,420.34592,0,0,1-23.78-139.83c0-176.76,108.94-328.08,263.34-390.48a422.11757,422.11757,0,0,1,344,12.87C921.74331,141.1188,1017.36324,284.39882,1017.36324,449.9988Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M782.70333,72.38882v532.01h-344v-544.88a422.11757,422.11757,0,0,1,344,12.87Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M521.485,314.99758c9.3319-15.43417,20.38981-31.91327,37.70741-36.953,20.055-5.83628,40.65646,5.75771,58.13126,17.19859A1693.94636,1693.94636,0,0,1,768.07446,406.31451l-.0527.59912q-56.24626-3.87885-112.4924-7.75763c-27.092-1.86831-55.11468-3.99432-79.05647-16.81052-9.0851-4.86325-17.9411-11.35959-28.236-11.81227-12.79047-.56236-23.94295,8.37051-32.70725,17.70329C463.686,443.443,448.68343,527.86682,390.52,576.36982A1845.84726,1845.84726,0,0,1,521.485,314.99758Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#f2f2f2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M807.86486,85.95834c-.87-.58-1.75-1.13-2.62-1.69a380.24064,380.24064,0,0,0-80.31-38.93l-6.54,90.22h-41.46v-103.39c-2.61-.54-5.24-1.05-7.87-1.53v104.92H619.79475A102.26991,102.26991,0,0,1,517.52484,33.28846v-.0001c-2.64.57-5.26,1.18-7.88,1.83v100.44h-40.13l-6.23-86.03a380.85838,380.85838,0,0,0-81.94,43.53c-.44.3-.88.61-1.31.91-2.21,1.55-4.39,3.13-6.56,4.73005v502.19h118.27l-2.09-28.95-11.5-316.95h231.59l-11.5,316.95-2.09,28.95h116.96v-511.45Q810.50479,87.66839,807.86486,85.95834Zm-298.22,142.78h-33.39l-6.17-85.3h39.56Zm159.42,0H612.98486v-1.69a6.17976,6.17976,0,0,0-6.19-6.18h-24.38a6.17757,6.17757,0,0,0-6.18,6.18v1.69h-58.71v-85.3h151.54Zm7.87,0v-85.3h40.89l-6.17,85.3Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M993.29435,590.64659c-.01.03-.01995.05005-.03.08-.07.21-.14.4-.22.61v.01q-5.115,14.37-11.24,28.26l-771.24-.84q-6.21-14.17492-11.4-28.87a.185.185,0,0,1-.02-.06995Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 394.71108,
    y: 564.93783,
    width: 135,
    height: 18,
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M391.37332,770.20882q.72006-6.34506,1.99-12.61a146.2005,146.2005,0,0,1,28.98-61.94c8.25.46,15.48-.8,16.17-16.78.13-2.84,2.24-5.31,2.7-8.11-.78.11-1.59.17-2.37.22-.25.01-.51.03-.75.04h-.09a4.48911,4.48911,0,0,1-3.69-7.32c.34-.41.68-.83,1.02-1.25.51-.65,1.04-1.28,1.56-1.92.06-.07.11-.13.17-.2.59-.73,1.18-1.46,1.78-2.19a13.00546,13.00546,0,0,0-4.26-4.12c-5.95-3.49-14.16-1.07-18.46,4.31-4.31,5.38-5.13,12.94-3.63,19.66,1.28,5.76,4.07,11.04,7.2,16.06-.32.41-.66.81-.98,1.23a147.30448,147.30448,0,0,0-15.35,24.31995c1.22-9.53-13.69-43.93-19.46-51.22-6.93-8.75-21.13-4.93-22.35,6.17-.01.1-.03.21-.04.32.86.48,1.7.99,2.52,1.54a6.1491,6.1491,0,0,1-2.48,11.19l-.13.02c-11.46,16.37,25.29,58.98,34.5,49.42a145.10452,145.10452,0,0,0-5.53,19.94,147.47532,147.47532,0,0,0-2.56,18.09,142.31363,142.31363,0,0,0,.11,22.99,2.51,2.51,0,0,1-.04-.27c-2.05-16.66-37.12-41.43-47.36-39.37-5.9,1.19-11.71.92-10.81,6.87.01.1.03.19.04.29a39.40435,39.40435,0,0,1,4.63,2.23c.86.48,1.7,1,2.52,1.54a6.15739,6.15739,0,0,1-1.56994,10.99q6.525,5.145,13.25,10.06c.71.52,1.42,1.04,2.13995,1.54q8.77506,6.33,17.9,12.2,11.13,7.17,22.74,13.66c1.06.59,2.12,1.18,3.19,1.76a143.52854,143.52854,0,0,1-4.06-33.81A139.72284,139.72284,0,0,1,391.37332,770.20882Zm5.47-35.73.02-.03a.07626.07626,0,0,1-.02.05Zm-7.97,71.91-.31-.69c.01-.51.01-1.01,0-1.53,0-.13995-.03-.28-.03-.42.12.89.22,1.78.35,2.67Zm45.93,1.36c.11-.46.2-.78.31-1.24-.04-.1-.08-.2-.12-.29-3.33-7.93-20.91,8.06-28.51,19.63q13.35,6.75,27.23,12.58c.62-.78,1.26-1.55,1.89-2.33.06-.07.11-.13.16-.2,1.36-1.68,2.73-3.34,4.08-5.02.01-.33.01-.66.01-.98a60.25046,60.25046,0,0,0-1.76-14.29A4.53593,4.53593,0,0,1,434.80331,807.7488Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M651.12082,599.6243a19.952,19.952,0,0,0,29.48674-8.15653l70.59455,6.603-17.33122-32.51408L669.49015,564.271a20.06011,20.06011,0,0,0-18.36928,35.35313Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#ffb6b6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M722.70333,597.39882l97.69042,10.952.33663-.43078c.64425-.82344,64.56564-82.64615,75.30539-102.12391a58.89048,58.89048,0,0,0,6.81965-38.57106l-.07326-.32417-.25427-.215a29.885,29.885,0,0,0-37.36866-.8194,211.683,211.683,0,0,0-61.088,75.48336l-8.07961,16.821-73.28832,7.22795Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#273679"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M643.44574,826.24119l-18.82,43.82q-4.05.285-8.11.46c-2.14.11-4.27.19-6.42005.25l-.73.23-.6-.19q-4.335.13494-8.7.17c-1.23.01-2.46.02-3.7.02-.58,0-1.16,0-1.74-.01l1.25-4.28,1.47-5.06995,5.84-20.08,8.43-28.99,12.54,5.38Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#ffb6b6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M779.05572,829.40116q-14.505,7.00507-29.6,12.89l-9.84-16.55,31.72-13.93Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#ffb6b6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M845.98572,754.18119v34.86q-8.775,6.48-17.9,12.5v-47.36Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#cacaca"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M908.86572,732.10118q-7.545,8.37-15.54,16.31a421.16821,421.16821,0,0,1-39.88,35h-79.8a14.87932,14.87932,0,0,1-11.19-5.07l-.01-.03a14.72686,14.72686,0,0,1-3.36005-6.6l-.01-.02a15.30172,15.30172,0,0,1-.34-3.2v-21.47a14.92992,14.92992,0,0,1,14.91-14.92Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M941.74573,648.30119l-8.65,37.06a77.90193,77.90193,0,0,1,.84,16.24q-6.15006,8.25-12.69,16.17-6.03,7.30507-12.38,14.33-7.545,8.37-15.54,16.31c-13.88,4.36-30.24,6.14-47.34,6.26-5.9.05-11.89-.11-17.9-.43-24.37-1.28-49.02-5.19-69.21-9.25-5.34-1.06-10.36-2.14-14.98-3.19-8.75-1.97-16.07-3.81-21.37006-5.21-5.97-1.56-9.37-2.57-9.37-2.57l-22.71,38.03-20.62,34.52-26.57,33.91q-3.81006.345-7.63.58-4.05.285-8.11.46c-2.14.11-4.27.19-6.42005.25l-.73.23-.6-.19-9.64-3.07-3.25-1.03-11.69-3.72s2.61-8.22,7.18-21.93c1.68-5.03,13.58-42.22,26.03-74.69,3.68994-9.64,7.51-19.42,11.43994-29.15,3.22-7.99,6.5-15.95,9.82-23.8,5.77-13.61,33.65-20.95,66.48-24.8,1.67-.19,3.35-.38,5.04-.56,16.73-1.76,34.48-2.67,51.08-3.09,8.31-.21,16.33-.29,23.79-.3q3.61506,0,7.03.02h.01c6.15.03,11.81006.12,16.79.22.97.02,1.91.05,2.83.07h.01c.62.01,1.23.03,1.83.04,10.89.28,17.57.62,17.57.62l2.59-20.32.53-4.1.5-3.9v-.01l.06-.49.41-.01,7.2-.14,60.52-1.18,25.77761-1.09237Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M777.51575,812.70121c-2.47,1.26-4.96,2.5-7.46,3.7q-14.505,7.00507-29.6,12.89c-2.87006,1.13-5.75,2.22-8.66,3.27-.32-.45-.65-.9-.98-1.35-13.88-19.05-22.52-31.19-40.37-59.16-7.47-11.7-14.98-23.9-22.27-36.36l52.78-24.64,5.92-2.76,17.02,33.51,15.18,29.89,3.38,6.65Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 687.76443,
    cy: 331.42827,
    r: 48.62546,
    fill: "#ffb6b6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M949.92572,511.57121c-.4-40.16.78-28.53-2.4-42.36-8.54-37.18-43.99-43.96-50.17-44.8a13.64475,13.64475,0,0,0-18.45-7.61l-11.83132,6.13544c-11.47,5.25-4.50865,12.83453-8.46867,24.80456l-4.16,12.7-34.09,94.23,6.9,35.85.01.02,4.65,24.15,13.78762,15.70762-.25759-2.50761-.31.48-.01.01-.8,1.19c1.11.61,2.21,1.21,3.29,1.81q4.2,2.31,8.19,4.53c.64.36,1.27.71,1.9,1.07h.01c.4.22.80005.44,1.19.66,9.98,5.58-26.96,15.74-18.75,20.51,1.14.66,2.27,1.32,3.38,1.97,37.8,22.11,67.96,49.65,77.71,57.65q6.54-7.92,12.69-16.17,5.58-7.455,10.81-15.17c.61-4.02,1.02-8.04,1.42-11.98.48-4.74-2.02-48.65-1.18-53.48.37-2.14-1.05-4.17-2.42-6.13-1.27-1.83-2.47-3.55-2.22-5.17.26-1.67,2.1-3.49,3.89-5.26,1.95-1.94,3.97-3.94,4.26-6.05.8-5.88-2.49-11.78-1.87-17.7q1.53-14.445,2.35-28.98Q950.13074,531.61119,949.92572,511.57121Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#273679"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M675.66113,610.0611a19.952,19.952,0,0,1,30.53533,1.89492l67.71168-21.03135-10.24723,35.39111-62.72916,14.546a20.06012,20.06012,0,0,1-25.27055-30.80056Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#ffb6b6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M757.75092,629.64l125.68249-25.91161-32.61794,8.07909c.36985-.97793,37.02907-98.12215,41.48215-119.91425a58.89049,58.89049,0,0,0-4.97429-38.85217l-.16646-.28765-.30674-.12951a29.885,29.885,0,0,0-35.91772,10.34437,211.68306,211.68306,0,0,0-35.84187,90.24876l-2.70466,18.46373-44.3115,13.25584Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#273679"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M523.5256,590.06885a6.4162,6.4162,0,0,0,6.1831,4.331l26.49183-.68178a6.32848,6.32848,0,0,0,5.98085-4.657l3.74888-40.08721a9.79394,9.79394,0,0,0,4.23793.87078,9.66133,9.66133,0,0,0-.4849-19.31658,8.18458,8.18458,0,0,0-1.73618.18057,6.54764,6.54764,0,0,0-4.874-2.103l-40.75051,1.05229a5.85307,5.85307,0,0,0-1.00519.1248,6.36455,6.36455,0,0,0-4.87318,8.26464ZM566.69906,546.252l2.66763-9.55274a6.50649,6.50649,0,0,0,.02037-3.37458c.12943-.00034.24362-.06169.37306-.062a6.91049,6.91049,0,0,1,.32357,13.81714A6.50522,6.50522,0,0,1,566.69906,546.252Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M521.31736,529.78271c.86818,4.96412,10.62909,8.45387,22.36585,7.84729,10.79271-.49726,19.61746-4.287,21.23421-8.7785a6.02511,6.02511,0,0,0-1.84436-.24588l-40.75051,1.05229A5.85307,5.85307,0,0,0,521.31736,529.78271Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#3f3d56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M344.10608,493.49293v85.704a4.12233,4.12233,0,0,0,4.11906,4.11907H475.22963a4.12231,4.12231,0,0,0,4.11906-4.11907v-85.704a4.12431,4.12431,0,0,0-4.11906-4.11452H348.22514A4.12433,4.12433,0,0,0,344.10608,493.49293Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M347.08554,494.55929v83.58039a2.20523,2.20523,0,0,0,2.20141,2.20141H474.1724a2.20521,2.20521,0,0,0,2.20141-2.20141V494.55929a2.20621,2.20621,0,0,0-2.20141-2.206H349.287A2.20623,2.20623,0,0,0,347.08554,494.55929Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#273679"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M341.4499,595.91146a2.46988,2.46988,0,0,0,1.94347.92984H479.38532a2.50242,2.50242,0,0,0,2.44606-3.0157l-2.111-10.02722a2.50694,2.50694,0,0,0-1.55811-1.81784,2.42471,2.42471,0,0,0-.888-.1675H345.496a2.42455,2.42455,0,0,0-.888.1675,2.5067,2.5067,0,0,0-1.5581,1.81784l-2.111,10.02722A2.50049,2.50049,0,0,0,341.4499,595.91146Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 472.11993,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(773.06505 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 463.74295,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(756.31109 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 455.36597,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(739.55713 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 446.98899,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(722.80316 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 438.61201,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(706.0492 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 430.23502,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(689.29523 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 421.85804,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(672.54127 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 413.48106,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(655.78731 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 405.10408,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(639.03334 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 396.7271,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(622.27938 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 388.35012,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(605.52542 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 379.97313,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(588.77145 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 371.59615,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(572.01749 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 363.21917,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(555.26352 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 354.84219,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(538.50956 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 346.46521,
    y: 583.61891,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(521.7556 1140.75211) rotate(-180)",
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 472.21892,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(773.26303 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 463.84194,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(756.50906 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 455.46496,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(739.7551 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 447.08797,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(723.00113 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 438.71099,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(706.24717 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 430.33401,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(689.49321 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 421.95703,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(672.73924 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 413.58005,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(655.98528 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 405.20306,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(639.23132 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 396.82608,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(622.47735 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 388.4491,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(605.72339 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 380.07212,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(588.96942 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 371.69514,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(572.21546 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 363.31816,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(555.4615 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 354.94117,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(538.70753 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 346.56419,
    y: 587.8074,
    width: 4.18849,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(521.95357 1149.12909) rotate(-180)",
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 402.68997,
    y: 592.83359,
    width: 33.50793,
    height: 2.51309,
    rx: 0.48819,
    transform: "translate(663.52456 1159.18147) rotate(-180)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M648.32293,591.25093l56.83985-49.69388c2.70269-2.3629-2.45138,4.67679-.0884,7.37958s11.34765.04451,8.645,2.40741l-56.83985,49.69388-14.39438,3.28664Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M648.32293,591.25093l1.37767-1.20447a15.76262,15.76262,0,0,1,4.83,3.74695,15.92864,15.92864,0,0,1,3.39531,6.32961l-1.04646.9149-11.47226,2.618-2.92212.66866,1.21839-2.73887Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#ccc"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M643.7035,601.58569a2.97777,2.97777,0,0,1,1.70373,2.07021l-2.92212.66866Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.18331,431.97878c-5.36,8.02-13.94,13.57-23.18,16.32a48.48669,48.48669,0,0,1-11.54,1.96,43.63174,43.63174,0,0,0-3.43-12.82,36.02165,36.02165,0,0,1-1.78,12.79,42.8682,42.8682,0,0,1-16.87-4.52c-10.25-5.25-18.14-15.29-19.89-26.68-2.06-13.30005,3.97-26.36,6.15-39.64,2.19-13.28-1.92-30.1-14.92-33.59-9.9-2.66-8.79-1.51-17.02,4.6,8.56092,12.65821-23.05963,59.045-36,55-7.31622-2.28695-12-9-13.51-9-10.17,17.52,8.98,47.04-10.32,53.17l1.59-1.59c11.65-14.33-12.7-44.66-1.05-58.99,3.25-4.01,6.71-8.76,5.75-13.83-.91-4.82-8.56-7.37-10.8-3.41,4.03-9.23-1.92-21.55-11.77-23.92-8.75-2.11-8.59.49-17.37,1.62a43.57308,43.57308,0,0,0-3.19-11.01,35.72529,35.72529,0,0,1-1.31,11.22,14.08849,14.08849,0,0,1-8.52-3.08c-7.16-5.77-5.71-17.89.68-24.5,6.4-6.61,15.91-8.99,24.98-10.53,2.63665-18.36081,53.29522-20.27612,60.01-1.93,2.86-13.7,20.01-20.81,33.34-16.56s22.58,16.7,27.45,29.82c4.87,13.11,6.23,27.22,9.23,40.88s8.07,27.57,18.51,36.88c10.44,9.3,27.45,12.38,38.45,3.74C1026.32333,413.37881,1024.53341,423.94881,1019.18331,431.97878Z",
    transform: "translate(-175.36331 -28.9988)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoexams);
export default __webpack_public_path__ + "static/media/noexams.8d3f38d0d3e1aebdb96279b781b9c7fd.svg";
export { ForwardRef as ReactComponent };